module.exports = __webpack_public_path__ + "static/img/personBg.eb86018.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personBg.png
// module id = DIbt
// module chunks = 2